<template>
	<edit-user-form form-type="staffPersonalInfo">
		<template #default="{ form, rules, inputColor, canEdit, update }">
			<v-row class="pa-2" dense>
				<!-- FIRST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.firstName"
						:rules="[rules.required]"
						:color="inputColor"
						label="First Name"
						:readonly="!canEdit"
						@input="update(['firstName', $event])"
					/>
				</v-col>
				<!-- LAST NAME -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.lastName"
						:rules="[rules.required]"
						:color="inputColor"
						label="Last Name"
						:readonly="!canEdit"
						@input="update(['lastName', $event])"
					/>
				</v-col>
				<!-- EMAIL -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.email"
						:rules="[rules.required, rules.email]"
						:color="inputColor"
						label="Email"
						type="email"
						:readonly="!canEdit"
						@input="update(['email', $event])"
					/>
				</v-col>
				<!-- JOB TITLE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.jobTitle"
						:color="inputColor"
						label="Job Title"
						:readonly="!canEdit"
						@input="update(['jobTitle', $event])"
					/>
				</v-col>
				<!-- PRIMARY PHONE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.primaryPhone"
						:rules="[rules.phone]"
						:color="inputColor"
						label="Primary Phone"
						:readonly="!canEdit"
						@input="update(['primaryPhone', $event])"
					/>
				</v-col>
				<!-- SECONDARY PHONE -->
				<v-col cols="12" sm="6">
					<v-text-field
						v-model="form.data.secondaryPhone"
						:rules="[rules.phone]"
						:color="inputColor"
						label="Secondary Phone"
						:readonly="!canEdit"
						@input="update(['secondaryPhone', $event])"
					/>
				</v-col>
			</v-row>
		</template>
	</edit-user-form>
</template>

<script>
import EditUserForm from "./EditUserForm";

export default {
	components: { EditUserForm },
};
</script>
